import { format, utcToZonedTime } from "date-fns-tz";

const TicketsInfo = ({ tickets_info, currency, styles, formatPriceWithCurrency }) => {

  return (tickets_info.tickets.length > 0) && (
    <div className={styles.cartItem}>
      <h3>Tickets</h3>
      <div className={styles.cro1381HotelMeta} id="hotel-tickets-wrapper">
        {tickets_info.tickets.map((ticket, index) => {
          return (
            <div key={index} data-testId="hotel-tickets">
              <div
                className={styles.product + " " + styles.ticketDesc}
                data-testId="hotel-tickets-title"
              >
                <p data-testId="hotel-ticket-title">{ticket.seo_title}</p>
                {ticket.dates.map((date, index2) => {
                  return (
                    <div
                      className={styles.cro1381ItemSpace}
                      data-testId="hotel-tickets-info"
                    >
                      {ticket.extra_info === "" && date !== "" && (
                        <>
                          <p
                            className={styles.productInfo}
                            data-testid="hotel-tickets-dates"
                          >
                            {format(
                              utcToZonedTime(new Date(date.date), "UTC"),
                              "do MMM yyyy",
                              { timeZone: "UTC" }
                            )}
                          </p>{" "}
                        </>
                      )}
                      <p
                        className={styles.productInfo}
                        data-testId="hotel-tickets-details"
                      >
                        {ticket.extra_info !== ""
                          ? ticket.extra_info
                          : `${date.time !== "" ? date.time : "All Day"}: ${
                              date.booked_for.total_ticket_qty > 0
                                ? `${date.booked_for.total_ticket_qty} x People`
                                : `${date.booked_for.adult} x Adult${
                                    date.booked_for.child > 0
                                      ? `, ${date.booked_for.child} x Child`
                                      : ""
                                  }`
                            }`}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        <p className={styles.ticketsTotal}>
          <span className={styles.price} data-testId="tickets-total">
            {formatPriceWithCurrency(tickets_info.total_tickets_price)}
          </span>
        </p>
      </div>
    </div>
  );
};

export default TicketsInfo;
